import React from "react";
import Helmet from "react-helmet";
import { Link } from "gatsby";
import { Features } from "../components/home/Features";
import { Footer } from "../components/home/Footer";
import CopyIcon from "../icons/CopyIcon";
import GitHubIcon from "../icons/GitHubIcon";

const InstallButton = () => {
  const installText = "pip install -U Canopus";
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(installText);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <button
      type="button"
      className="w-full sm:w-auto flex-none bg-gray-50 text-gray-400 hover:text-gray-900 font-mono leading-6 py-3 sm:px-6 border border-gray-200 rounded-xl flex items-center justify-center space-x-2 sm:space-x-4 focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-gray-300 focus:outline-none transition-colors duration-200"
      onClick={copy}
    >
      <span className="text-gray-900">
        <span className="hidden sm:inline text-gray-500" aria-hidden="true">
          ${" "}
        </span>
        {installText}
      </span>
      <span className="sr-only">(click to copy to clipboard)</span>
      <CopyIcon />
    </button>
  );
};

const Home = () => {
  return (
    <div className="space-y-8 sm:space-y-16 md:space-y-20 lg:space-y-24 overflow-hidden">
      <Helmet>
        <meta
          key="twitter:title"
          name="twitter:title"
          content="Canopus - The fully fledged GraphQL web framework for Python."
        />
        <meta
          key="og:title"
          property="og:title"
          content="Canopus - The fully fledged GraphQL web framework for Python."
        />
        <title>
          Canopus - The fully fledged GraphQL web framework for Python.
        </title>
      </Helmet>
      <header className="max-w-screen-lg xl:max-w-screen-xl mx-auto">
        {/* <!-- Home header --> */}
        <div className="px-4 sm:px-6 md:px-8 mb-14 sm:mb-20 xl:mb-8">
          <div className="border-b border-gray-200 py-4 flex items-center justify-between mb-16 sm:mb-20 -mx-4 px-4 sm:mx-0 sm:px-0">
            <div className="flex items-center justify-center gap-x-4 sm:gap-x-8 ml-6 sm:ml-10 py-2">
              <Link
                to="/docs/intro"
                className="text-base leading-6 font-medium hover:text-gray-600 transition-colors duration-200"
              >
                <span className="sm:hidden">Docs</span>
                <span className="hidden sm:inline">Documentation</span>
              </Link>
              <a
                href="https://github.com/canopusgraphql/canopus"
                className="text-gray-400 hover:text-gray-500 transition-colors duration-200"
              >
                <span className="sr-only">Canopus GraphQL on GitHub</span>
                <GitHubIcon />
              </a>
            </div>
          </div>
          {/* <!-- Hero --> */}
          <div className="flex flex-col items-center mb-8 sm:mb-10 text-center">
            <h1 className="text-4xl sm:text-6xl lg:text-7xl leading-none font-extrabold tracking-tight text-gray-900 mt-10 mb-8 sm:mt-14 sm:mb-10">
              The{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-purple-700">
                fully fledged
              </span>{" "}
              GraphQL
              <br className="hidden xl:inline" /> web framework for Python
            </h1>
            {/* <!-- Description --> */}
            <h3 className="max-w-screen-md">
              Canopus makes it easy to build GraphQL servers, with all the
              features you need in production- Caching, batch loading, modular
              project structures, authorization, input validation and more.
            </h3>
          </div>
          <div className="flex flex-wrap space-y-4 sm:space-y-0 sm:space-x-4 text-center items-center justify-center">
            <Link
              to="/docs/intro"
              className="w-full sm:w-auto flex-none bg-gray-900 hover:bg-gray-700 text-white text-lg leading-6 font-semibold py-3 px-6 border border-transparent rounded-xl focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-gray-900 focus:outline-none transition-colors duration-200"
            >
              read the docs
            </Link>
            <InstallButton />
          </div>
        </div>
      </header>
      <hr className="max-w-screen-lg mx-auto" />
      <Features />
      <Footer />
    </div>
  );
};

export default Home;
